import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Modules
import { NgSelectModule } from '@ng-select/ng-select';
import { GoogleMapsModule } from '@angular/google-maps';

// Pipes
import { BooleanPipe } from './pipes/boolean.pipe';
import { SafePipe } from './pipes/safe.pipe';

// Components
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { ContactFormComponent } from './components/contact-form/contact-form.component';

// Directives
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ReadMoreComponent } from './components/read-more/read-more.component';

@NgModule({
  declarations: [
    BooleanPipe,
    SafePipe,
    StarRatingComponent,
    ContactFormComponent,
    ReadMoreComponent,
    ClickOutsideDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    BooleanPipe,
    SafePipe,
    GoogleMapsModule,

    StarRatingComponent,
    ContactFormComponent,

    // Directives
    ClickOutsideDirective,
    ReadMoreComponent,
    RouterModule
  ]
})
export class SharedModule { }
